const SUBSCRIPTION_RESET = 'SUBSCRIPTION_RESET'
const SUBSCRIPTION_SAGA_CREATE = 'SUBSCRIPTION_SAGA_CREATE'

const _default = {
    SUBSCRIPTION_RESET,
    SUBSCRIPTION_SAGA_CREATE
}

export default _default